exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".opensource-main {\n  width: 100%;\n}\n", ""]);

